import { writable } from 'svelte/store';
import { cleanCountries } from '../components/Contents/Countries/countries.util';
export const Countries = writable([]);
Countries.subscribe(content => {
    if (content.find(country => country.code === 'ZZ')) {
        // Mandatory to avoid infinite loop (once countries have been cleaned, we shouldn't call the clean function again)
        Countries.set(cleanCountries(content));
    }
});
